import "./styles.scss";
import Inner from "./components/inner/Inner";
import "./helper/i18n";
import Contact from "./components/contact/Contact";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { useEffect } from "react";
import i18n from "./helper/i18n";

const LanguageWrapper = ({ children }) => {
  const { lang } = useParams();
  useEffect(() => {
    if (lang && ["ka", "en", "ru", "tr"].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/ka" replace />} />
        <Route
          path="/:lang"
          element={
            <LanguageWrapper>
              <Inner />
            </LanguageWrapper>
          }
        />
        <Route
          path="/:lang/contact"
          element={
            <LanguageWrapper>
              <Contact />
            </LanguageWrapper>
          }
        />
        <Route
          path="/:lang/services/:serviceSlug"
          element={
            <LanguageWrapper>
              <Inner />
            </LanguageWrapper>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
